export default "__VITE_ASSET__DCZSXPVG__"